import React from 'react';
import ReactDOMServer from 'react-dom/server';
import Linkify from 'linkify-react';

class MessengerMessage extends React.Component {


	render() {
		var moment = require('moment');
		var datecreated = this.props.chat.DateCreated ? this.props.chat.DateCreated : this.props.chat.dateCreated;

		var date = moment(datecreated, "MM-DD-YYYY hh:mm A z");
		var parts = datecreated.split(" ");
		var timezone = parts.pop();
		var name = null;
		if (!this.props.chat.user) {
			var is_business = true;
		} else {
			var is_business = (this.props.chat.user.isBusiness == 1 ? true : false);
		}
		var is_auto = false;
		if (!is_business) {
			if (this.props.hidename) {
				name = __("Hidden");
			} else {
				name = this.props.chat.user.firstname ?? '' + " " + this.props.chat.user.lastname ?? '';
			}
		} else {
			if (typeof this.props.chat.Attributes === 'string' || this.props.chat.Attributes instanceof String) {
				is_auto = (this.props.chat.Attributes.toUpperCase().indexOf("AUTO-RESPONSE") === -1 ? false : true);
				if (this.props.chat.Attributes.toUpperCase().indexOf("IS_AUTO_REVIEW") !== -1) {
					is_auto = true;
				}
			} else {
				is_auto = (this.props.chat.Attributes.name.toUpperCase().indexOf("AUTO-RESPONSE") === -1 ? false : true);
				if (this.props.chat.Attributes.is_auto_review) {
					is_auto = true;
				}
			}
			if (is_auto) {
				name = __("Feedback Auto-response");
			} else {
				if (!this.props.chat.user) {
					name = __("Deleted User");
				} else {
					name = this.props.chat.user.firstname + " " + this.props.chat.user.lastname;
				}
			}
		}


		var classes = [];
		if (this.props.chat.user != null && (this.props.chat.user.isBusiness == 1 || this.props.chat.user.isBusiness == "1")) {
			const msg = 'out';
			classes = ['row outgoing_msg', 'outgoing_info text-center col-lg-2 col-md-3 col-3', 'outgoing_msg_img', 'outgoing_msg_txt px-2', 'sent_msg col-md-8 col-8 pr-0'];
		} else {
			const msg = 'in';
			classes = ['row incoming_msg', 'incoming_info text-center col-lg-2 col-md-3 col-3', 'incoming_msg_img', 'incoming_msg_txt px-2', 'received_msg col-md-8 col-8 pl-0'];
		}

		var initial_span;
		if (classes[0] == "row outgoing_msg" || (classes[0] == "row incoming_msg" && !this.props.hidename)) {
			if (is_auto) {
				initial_span = <span className="user_initials autoresponse"><i className="fal fa-robot"></i></span>;
			} else {
				initial_span = <span className="user_initials">
					{this.props.chat.user && this.props.chat.user.firstname ? (this.props.chat.user.firstname.substring(0, 1) + (this.props.chat.user.lastname ? this.props.chat.user.lastname.substring(0, 1) : "")) : "?"}
				</span>;
			}
		} else {
			initial_span = <span className="user_initials">H</span>;
		}

		if (this.props.red_alerts_list) {
			var keywords = this.props.red_alerts_list;
			if (keywords) {
				var chat_red_text = ReactDOMServer.renderToStaticMarkup(<Linkify>{this.props.chat.Body}</Linkify>);
				var i;
				for (i = 0; i < keywords.length; i++) {
					var keyword = keywords[i];
					if (this.props.chat.Body.toLowerCase().includes(keyword.toLowerCase())) {
						chat_red_text = chat_red_text.replace(new RegExp(keyword, "ig"), '<span class="text-danger font-weight-bold">' + keyword + '</span>');
					}
				}
			}
		}
		return (
			<div className="chat_widget_body">
				<div className={classes[0]}>
					<div className={classes[1]}>
						<div className={classes[2]}>
							{initial_span}
						</div>
						<div className={classes[3]}>
							{this.props.chat.user && !is_auto ? this.props.chat.user.title : "Auto"}
						</div>
					</div>
					<div className={classes[4]}>
						{chat_red_text &&
							<p className={"chat_texts " + (is_auto ? 'autoresponse' : '')} dangerouslySetInnerHTML={{ __html: chat_red_text ?? this.props.chat.Body }}></p>
						}
						{!chat_red_text &&
							<p className={"chat_texts " + (is_auto ? 'autoresponse' : '')}><Linkify>{this.props.chat.Body}</Linkify></p>
						}
						<span className="time_date">
							{date.format("h:mm A")} {timezone} | {date.format("MMMM DD")} |{" "}
							{name}
						</span>
					</div>
				</div>
			</div>
		);
	}
}

export default MessengerMessage;
// function mapStateToProps(state) {
// 	return { state:state }
// }

// export default connect(mapStateToProps)(FeedbackList)
